import HomeComponent from './Home.vue'
export default HomeComponent
